/**
 * Status types for different entities
 */
export type PublishStatus = "published" | "draft";
export type ActiveStatus = "active" | "inactive";
export type ExpiryStatus = "active" | "expired" | "scheduled";
export type RequestStatus = "pending" | "approved" | "rejected";
export type TriggerStatus = "active" | "paused" | "disabled";
export type SubscriptionStatus = "active" | "expired" | "cancelled" | "pending";

export type StatusType =
  | PublishStatus
  | ActiveStatus
  | ExpiryStatus
  | RequestStatus
  | TriggerStatus
  | SubscriptionStatus;

/**
 * Helper function to get status from boolean
 */
export function getPublishStatus(isPublished: boolean): PublishStatus {
  return isPublished ? "published" : "draft";
}

export function getActiveStatus(isActive: boolean): ActiveStatus {
  return isActive ? "active" : "inactive";
}

/**
 * Helper function to get expiry status from dates
 */
export function getExpiryStatus(
  startDate: Date | null,
  endDate: Date | null
): ExpiryStatus {
  const now = new Date();

  if (startDate && startDate > now) {
    return "scheduled";
  }

  if (endDate && endDate < now) {
    return "expired";
  }

  return "active";
}
